import React from "react"
import logoUrl from "../../../assets/img/payment-icons/apple_pay.svg"

export default function ApplePayLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Apple Pay logo"
            style={sx}
        />
    )
}
